<template>
    <div class="register-popup">
            <div class="register-popup__close-btn" @click="close">
                <span>{{ params.messages.back }}</span>
                <svg class="icon" width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.50114 8.1139L1.60964 13L0 11.3815L4.89149 6.5L0 1.61846L1.61306 0L6.50455 4.89406L11.396 0L13 1.61846L8.10964 6.5L12.9932 11.3815L11.3892 12.9954L6.50114 8.1139Z"/>
                </svg>
            </div>
            <div class="register-popup__inner row">
                <div class="d6 md-5 register-popup__col register-popup__col-left">
                    <div class="register-popup__col-inner">
                        <div class="register-popup__col-left-title h2">{{ params.messages.leftTitle }}</div>
                    </div>
                </div>
                <div class="d6 md-7 sm-12 register-popup__col register-popup__col-right">
                    <div class="register-popup__col-inner">
                        <div class="register-popup__col-content">
                            <div class="register-popup__title h2">{{ params.messages.title }}</div>
                            <div class="register-popup__desc">{{ params.messages.text }}</div>
                            <div class="registrationTabs">
                                <AuthTabs v-model="state.form.type" @changeTab="changeTab" :tabs="tabs"/>
                                <form
                                    @submit="submitForm($event)"
                                    :action="params.formReg.action"
                                    :method="params.formReg.method"
                                    class="register-popup__form register-popup__form-volonter"
                                ><input type="hidden" name="type" :value="state.form.type">
                                    <div class="form-group row">
                                        <div class="col d6 sm-12" :class="'d'+field.greedLang" v-for="field in state.form.fields">
                                            <AInput
                                                v-if="field.type==='text'||field.type=='email'||field.type=='phone' || field.type=='file' || field.type=='bool'"
                                                :name="field.name"
                                                :type="field.type"
                                                :req="field.required"
                                                v-model="field.value"
                                                :error="field.error"
                                                :validator="validator"
                                                :label="field.title+(field.required?' *':'')"
                                                :placeholder="field.placeholder"
                                                :staticLabel="true"
                                            />
                                            <a-checkbox
                                                v-if="field.type=='checkbox'"
                                                :name="field.name"
                                                :disabled="field.disabled"
                                                :req="field.required"
                                                :error="field.error"
                                                :validator="validator"
                                                :label="field.title+(field.titleFor[state.form.type]?' '+field.titleFor[state.form.type]:'')"
                                                :checked="field.disabled||field.value=='Y'?true:false"
                                                v-model="field.value"
                                            />
                                        </div>
                                    </div>
                                    <br>
                                    <ABtn :label="params.messages.regBtn" class="d12 primary"/>
                                </form>
                            </div>
                            <div class="register-popup__bottom">
                                <span>{{ params.messages.logInText }} <a href="" @click.prevent.stop="setLoginForm">{{
                                        params.messages.logInlink
                                    }}</a></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>

import {ref, reactive, computed, onMounted} from 'vue'
import {useStore} from 'vuex'
import {ABtn, AInput, AModal, useAModal, ASelect, ACheckbox} from '../ui'
import {required, isEmail, isPhone, isIdentical} from '../../libs/Validators'
import {useFormSend} from '../../composables'
import useTabsValue from "../../composables/useTabsValue";
import {TAB_CODES} from "../../composables/useTabsValue";
import AuthTabs from "../forms/auth/AuthTabs";
import {AUTH_STATES} from "../../store/modules/auth";

export default {
    name: 'RegisterPopup',
    props: ['params'],
    components: {
        AuthTabs,
        ABtn,
        AInput,
        ACheckbox,
        ASelect,
        AModal,
    },
    setup: (props, ctx) => {
        const $store = useStore()

        const {registerTabsData} = useTabsValue(props, ctx)

        const state = ref({
            form: {
                processed: false,
                type: TAB_CODES.volunteer,
                fields: props.params.formReg.fields
            },
        })

        const modal = useAModal();

        const close = () => {
            modal.hide()
        }

        const tabs = registerTabsData

        const validator = (val, type, req) => {
            if (type === undefined) {
                type = event.target.attributes.type.value;
            }
            if (req === undefined) {
                req = event.target.attributes.req.value;
            }
            let res = true;
            switch (type) {
                case "phone":
                    res = isPhone(val);
                    break;
                case "email":
                    res = isEmail(val);
                    break;
            }
            if (res && req) {
              if(type=="checkbox") {
                res = val;
              } else {
                res = required(val);
              }
            }
            return res;
        };

        const submitForm = (e) => {

            state.value.form.processed = true;
            let send = true;
            for (let i in state.value.form.fields) {
                if (!validator(
                    state.value.form.fields[i].value ? state.value.form.fields[i].value : '',
                    state.value.form.fields[i].type,
                    state.value.form.fields[i].required,
                )
                ) {
                    send = false;
                    state.value.form.fields[i].error = true;
                } else {
                  state.value.form.fields[i].error = false;
                }
            }
            if (!send) {
                e.preventDefault()
            }
        }
        const setLoginForm = () => {
            $store.commit('auth/setAuthState', AUTH_STATES.login)
        }
        const changeTab = (v) => {
          state.value.form.type = v;

        }

        return {
            state,
            submitForm,
            close,
            validator,
            required,
            isEmail,
          changeTab,
            isPhone,
            tabs,
            setLoginForm
        }
    },
}
</script>

<style lang="scss">
.register-popup {
    background: #fff;
    width: 100%;
    height: 100vh;
    min-height: 100vh;
    overflow: auto;
    position: relative;

    &__inner {
        height: 100%;
        min-height: 100vh;
        margin: 0;
    }

    &__col {
        min-height: 100vh;

        &-left {
            padding-right: 8%;

            @include tablet {
                padding-right: 20px;
            }

            @include mobile {
                display: none;
            }

            .register-popup__col-inner {
                position: relative;
                height: 100%;
                background-image: url('/local/templates/main/img/register-popup-bg.jpg');
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
                padding: 60px 46px;

                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    pointer-events: none;
                    background: linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 31.28%);
                    opacity: 0.87;
                    transform: matrix(1, 0, 0, -1, 0, 0);
                }
            }

            &-title {
                color: #fff;
                position: absolute;
                left: 46px;
                bottom: 60px;
                width: 100%;
                max-width: 510px;
                margin: 0;
                padding-right: 16px;

                @include tablet {
                    left: 16px;
                    bottom: 30px;
                }
            }
        }

        &-right {
            padding: 40px 30px 40px 0px;
            @include tablet {
                padding: 40px 16px 40px 0px;
            }
            @include tablet {
                padding: 15px 15px 40px 15px;
            }

            .register-popup__col-inner {
                max-width: 684px;
                height: 100%;
                display: flex;
                align-items: center;

                @include mobile {
                    align-items: stretch;
                }
            }
        }

        &-content {
            width: 100%;
        }
    }

    &__title {
        margin: 0;
    }

    &__desc {
        font-size: 16px;
        line-height: 26px;
        color: var(--c-gray-120);
        margin-top: 10px;

        @include tablet {
            font-size: 14px;
            line-height: 20px;
            margin-top: 8px;
        }
    }

    &__form {
        margin-top: 28px;

        .form-group {
            display: flex;
            row-gap: rem(20);
        }

        .field {
            width: 100%;

            .label {
                left: 0;
                font-size: 14px;
                top: -24px;
                transform: none !important;
                color: #161515 !important;
            }

            .input {
                font-size: 14px;
            }
        }
    }

    &__bottom {
        margin-top: 30px;
        text-align: center;
        font-size: 14px;
        line-height: 20px;
    }

    &__close-btn {
        cursor: pointer;
        position: absolute;
        right: 30px;
        top: 26px;
        display: inline-flex;
        align-items: center;
        z-index: 1;
        @include tablet {
            font-size: 12px;
            right: 15px;
            top: 22px;
        }

        .icon {
            margin-top: 3px;
            margin-left: 10px;
            fill: #D8DCDE;
            transition: all .3s ease;
        }

        &:hover {
            .icon {
                fill: #6367A7;
            }
        }
    }
}

select {
  appearance: none;
}

</style>